<template>
  <div class="signDetailTable">
    <el-table
      :data="data"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="name" label="预警名称"></el-table-column>
      <el-table-column prop="contractName" label="合同名称"></el-table-column>
      <el-table-column prop="warnTime" label="预警时间">
        <template slot-scope="scope">
          <div>{{scope.row.warnTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="eventName" label="预警事件"></el-table-column>
      <el-table-column prop="concatState" label="通知方式">
        <template slot-scope="scope">
          <div class="notifyContent" v-if="scope.row.messageType">
            <span v-for="(item,index) in getNotifyType(scope.row.messageType)" :key="index">{{item}}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
            <div class="cursorPointer detail" @click="toDetail(scope.row)">
              <span class="icon"></span>
              删除
            </div>
          </div>
        </template>
      </el-table-column>-->
    </el-table>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toDetail(row) {
      this.$router.push("/personal/sign/detail");
    },
    getNotifyType(type) {
      let arrObject = {
        "1": "短信",
        "2": "邮件",
        "3": "站内通知"
      };
      let typeArr = type.split(",");
      console.log(typeArr);
      let transFormArr = [];
      typeArr.forEach(value => {
        transFormArr.push(arrObject[value]);
      });
      return transFormArr;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.notifyContent {
  display: flex;
  justify-content: space-around;
}
</style>
